export default {
  message: {
    tom: 'TOM',
    'tom.entryControlDesc': 'Beschreibung der Zutrittskontrolle',
    'tom.admissionControlDesc': 'Beschreibung der Zugangskontrolle',
    'tom.accessControlDesc': 'Beschreibung der Zugriffskontrolle',
    'tom.separationCommandDesc': 'Beschreibung des Trennungsgebots',
    'tom.pseudonymizationDesc': 'Beschreibung der Pseudonymisierung',
    'tom.transferControlDesc': 'Beschreibung der Weitergabekontrolle',
    'tom.inputControlDesc': 'Beschreibung der Eingabekontrolle',
    'tom.availControlDesc': 'Beschreibung der Verfügbarkeitskontrolle',
    'tom.recoverabilityDesc': 'Beschreibung der Wiederherstellbarkeit',
    'tom.orderControlDesc': 'Beschreibung der Auftragskontrolle',
    'tom.privacyManagementDesc': 'Beschreibung des Datenschutz-Management',
    'tom.incidentRespManagementDesc': 'Beschreibung des Incident-Response-Management',
    'tom.privacyPreallocationDesc': 'Beschreibung der Datenschutzfreundlichen Voreinstellungen',
    'tom.name': 'Bezeichnung',
    'tom.examState': 'Status',
    'tom.responsibleUser': 'Bearbeiter',
    'tom.responsibleAffiliate': 'Verantwortlicher',
    'tom.organizationalUnit': 'Organisationseinheit',
    'tom.measureNotes': 'Notwendige Maßnahmenbeschreibungen',
    'tom.isClientRespAffiliate': 'Mandant selbst ist Verantwortlicher',
    'tom.createdBy': 'Ersteller',
    measure: 'Maßnahme',
    'measure.name': 'Bezeichnung',
    'measure.description': 'Beschreibung',
    'measure.user': 'User',
    'measure.currentImplementation': 'Aktuelle Umsetzung',
    'measure.plannedImplementation': 'Geplante Umsetzung',
    'measure.pastImplementation': 'Vergangene Umsetzung',
    'measure.note': 'Notizen',
    'measure.createdBy': 'Ersteller',
    privacyAudit: 'Audit',
    'privacyAudit.name': 'Bezeichnung',
    'privacyAudit.auditor': 'Auditor',
    'privacyAudit.participants': 'Beteiligte',
    'privacyAudit.startDate': 'Beginn',
    'privacyAudit.endDate': 'Ende',
    'privacyAudit.categories': 'Relevante Kategorien',
    'privacyAudit.text': 'Text',
    'privacyAudit.conclusion': 'Fazit',
    'privacyAudit.isFinished': 'Abgeschlossen',
    'privacyAudit.createdBy': 'Ersteller',
    task: 'Aufgabe',
    'task.name': 'Bezeichnung',
    'task.user': 'Benutzer',
    'task.priority': 'Priorität',
    'task.status': 'Status',
    'task.description': 'Beschreibung',
    'task.deadline': 'Ende',
    'task.resubmission': 'Wiedervorlage',
    'task.createdBy': 'Ersteller',
    procedureDirectory: 'Verfahren',
    'procedureDirectory.isImpactAnalysisRequired': 'Erforderlichkeit einer Datenschutz-Folgeabschätzung',
    'procedureDirectory.auditCause': 'Grund für eine DSFA',
    'procedureDirectory.plannedProcessDesc': 'Systematische Beschreibung der geplanten Verarbeitungsvorgänge und der Zwecke der Verarbeitung',
    'procedureDirectory.appliedTechnology': 'die Eingesetzte Technik',
    'procedureDirectory.gatheredDataType': 'die Art der erhobenen Daten',
    'procedureDirectory.gatheredDataScope': 'der Umfang der erhobenen Daten',
    'procedureDirectory.dataCollectionCase': 'die Umstände der Datenerfassung und Verarbeitung',
    'procedureDirectory.dataCollectionPurpose': 'die Zwecke der Datenerfassung und Verarbeitung',
    'procedureDirectory.thoseAffected': 'die Betroffenen',
    'procedureDirectory.thoseResponsible': 'die Verantwortlichen',
    'procedureDirectory.isProcessingRequired': 'Ist die Verarbeitung im Hinblick auf den Zweck notwendig?',
    'procedureDirectory.isProcessingAppropriate': 'Ist die Verarbeitung im Hinblick auf den Zweck angemessen?',
    'procedureDirectory.respInterestStatement': 'die Darlegung des berechtigten Interesses der Verantwortlichen',
    'procedureDirectory.riskEvaluation': 'Bewertung der Risiken für die Rechte und Freiheiten der betroffenen Personen',
    'procedureDirectory.riskCorrectiveActions': 'Die zur Bewältigung der Risiken geplanten Abhilfemaßnahmen',
    'procedureDirectory.isDsfaClosed': 'Abgeschlossen',
    'procedureDirectory.name': 'Bezeichnung',
    'procedureDirectory.responsibleUser': 'Bearbeiter',
    'procedureDirectory.responsibleAffiliate': 'Verantwortlicher',
    'procedureDirectory.privacyOfficer': 'Datenschutzbeauftragter',
    'procedureDirectory.isPrivacyOfficerResponsible': 'Unternehmens-Datenschutzbeauftragter ist zuständig',
    'procedureDirectory.examState': 'Status',
    'procedureDirectory.organizationalUnit': 'Organisationseinheit',
    'procedureDirectory.dataProcessingStart': 'Beginn der Datenverarbeitung',
    'procedureDirectory.dataProcessingEnd': 'Ende der Datenverarbeitung',
    'procedureDirectory.isProcessingUnlimited': 'Unbefristete Datenverarbeitung',
    'procedureDirectory.notes': 'Bemerkungen zum Verfahren',
    'procedureDirectory.processingDesc': 'Zweckbeschreibung der Verarbeitung',
    'procedureDirectory.legalBasisDesc': 'Beschreibung der Rechtsgrundlage',
    'procedureDirectory.affectedGroupDesc': 'Beschreibung der Betroffenen Personengruppe(n)',
    'procedureDirectory.accessors': 'Zugriffsberechtigte Personen',
    'procedureDirectory.isPersonalDataSpecial': 'Es handelt sich um besondere Arten von personenbezogenen Daten (gemäß Art. 9 DSGVO) ',
    'procedureDirectory.isExecutedForPrincipal': 'Verfahren wird für Auftraggeber ausgeführt',
    'procedureDirectory.toms': 'TOMs',
    'procedureDirectory.receivers': 'Empfänger oder Kategorien von Empfängern',
    'procedureDirectory.sourceOfData': 'Beschreibung der Datenherkunft',
    'procedureDirectory.deletionPeriod': 'Regelfristen für die Löschung der Daten',
    'procedureDirectory.thirdCountryTransferStatus': 'Datenübermittlung in Drittstaaten',
    'procedureDirectory.dataTransferText': 'Datenübermittlung Text',
    'procedureDirectory.serviceDesc': 'Beschreibung der eingesetzten Tools / Dienstleistung',
    'procedureDirectory.recoveryInterestLevel': 'Wie schutzbedürftig sind die Daten für den Betroffenen?',
    'procedureDirectory.recoveryInterestLevelNotes': 'Kommentar',
    'procedureDirectory.attackProbability': 'Wie hoch ist die Eintrittswahrscheinlichkeit?',
    'procedureDirectory.attackProbabilityNotes': 'Kommentar',
    'procedureDirectory.hasScoring': 'Bewertung oder Scoring',
    'procedureDirectory.hasAutoDecision': 'Automatisierte Entscheidung, die eine rechtliche Auswirkung beinhaltet. (insbesondere bei Gefahr der Diskriminierung und Ausschluss von Personen)',
    'procedureDirectory.hasMethodicalMonitoring': 'Systematisches Monitoring',
    'procedureDirectory.hasSensitiveData': 'Sensible Daten oder Daten höchst persönlicher Art (besondere Kategorien personenbezogener Daten nach Artikel 9 DSGVO)',
    'procedureDirectory.hasMajorDataProcessing': 'Verarbeitung von Daten in erheblichem Ausmaß',
    'procedureDirectory.hasUnexpectedDataProcessing': 'Abgleich oder Kombination von Datensätzen, welche zu unterschiedlichen Zwecken verarbeitet werden und was außerhalb des Erwartungshorizonts der Betroffenen liegt.',
    'procedureDirectory.hasModernSolutions': 'Neuartige Nutzung oder Gebrauch neuer technologischer oder organisatorischer Lösungen',
    'procedureDirectory.hasRestrictions': 'Wenn betroffene Personen durch die Verarbeitung der Zugang zu einem Recht, der Inanspruchnahme einer Dienstleistung oder der Abschluss eines Vertrags verhindert, geändert oder erlaubt wird.',
    'procedureDirectory.hasNoCriteria': 'Keine der Kriterien liegen vor',
    'procedureDirectory.isRiskAnalysisClosed': 'Abgeschlossen',
    'procedureDirectory.isClientRespAffiliate': 'Mandant selbst ist Verantwortlicher',
    'procedureDirectory.createdBy': 'Ersteller',
    user: 'Benutzer/Mitarbeiter',
    'user.salutation': 'Anrede',
    'user.firstname': 'Vorname',
    'user.surname': 'Nachname',
    'user.phone': 'Telefon',
    'user.mobile': 'Handy',
    'user.fax': 'Fax',
    'user.city': 'Stadt',
    'user.zipcode': 'PLZ',
    'user.street': 'Straße',
    'user.email': 'E-Mail-Adresse',
    'user.department': 'Abteilung',
    'user.comment': 'Notiz',
    'user.username': 'Benutzername',
    'user.password': 'Neues Passwort',
    'user.isDelete': 'Gelöscht',
    'user.enabled': 'Aktiviert',
    'user.accountLocked': 'Gesperrt',
    'user.accountExpired': 'Abgelaufen',
    'user.dateCreated': 'Erstellt am',
    'user.createdBy': 'Ersteller',
    company: 'Firma',
    'company.name': 'Firma',
    'company.street': 'Straße',
    'company.zipCode': 'PLZ',
    'company.city': 'Ort',
    'company.country': 'Land',
    'company.phone': 'Telefon',
    'company.mobile': 'Handy',
    'company.fax': 'Fax',
    'company.email': 'E-Mail-Adresse',
    'company.web': 'Webseite',
    'company.chiefResponsibleJob': 'Leiter der verantwortlichen Stelle',
    'company.chiefDataProcessing': 'Leiter der Datenverarbeitung / IT',
    'company.profileResponsibleJob': 'Kurzprofil der Verantwortlichen Stelle',
    'company.isActive': 'Aktiv',
    'company.isDemo': 'Demo',
    'company.privacyOfficer.name': 'Name des Datenschutzbeauftragten',
    'company.privacyOfficer.firm': 'Firma',
    'company.privacyOfficer.street': 'Straße',
    'company.privacyOfficer.zip': 'PLZ',
    'company.privacyOfficer.location': 'Ort',
    'company.privacyOfficer.phone': 'Telefon',
    'company.privacyOfficer.fax': 'Fax',
    'company.privacyOfficer.email': 'E-Mail-Adresse',
    'company.privacyOfficer.requestDate': 'Bestellungsdatum zum Datenschutzbeauftragten',
    'company.privacyOfficer.isInternal': 'intern Angestellt',
    'company.training': 'Schulung',
    'company.createdBy': 'Ersteller',
    affiliate: 'Vertragspartner',
    'affiliate.affiliateType': 'Art',
    'affiliate.firm': 'Firma',
    'affiliate.isActive': 'Aktiv',
    'affiliate.isDelete': 'Gelöscht',
    'affiliate.salutation': 'Anrede',
    'affiliate.firstname': 'Vorname',
    'affiliate.surname': 'Nachname',
    'affiliate.comment': 'Kommentar',
    'affiliate.street': 'Straße',
    'affiliate.zip': 'PLZ',
    'affiliate.location': 'Ort',
    'affiliate.country': 'Land',
    'affiliate.state': 'Bundesland',
    'affiliate.phone': 'Telefon',
    'affiliate.phone2': 'Telefon 2',
    'affiliate.mobile': 'Handy',
    'affiliate.fax': 'Fax',
    'affiliate.email': 'E-Mail',
    'affiliate.web': 'Webseite',
    'affiliate.privacyOfficer': 'Datenschutzbeauftragter angelegt',
    'affiliate.createdBy': 'Ersteller',
    employee: 'Mitarbeiter',
    'employee.salutation': 'Anrede',
    'employee.firstname': 'Vorname',
    'employee.surname': 'Nachname',
    'employee.phone': 'Telefon',
    'employee.mobile': 'Handy',
    'employee.email': 'E-Mail-Adresse',
    'employee.department': 'Abteilung',
    'employee.comment': 'Notiz',
    'employee.username': 'Benutzername',
    'employee.password': 'Neues Passwort',
    'employee.isDelete': 'Gelöscht',
    'employee.isActive': 'Aktiv',
    'employee.isSent': 'Versendet',
    'employee.createdBy': 'Ersteller',
    department: 'Abteilung',
    'department.name': 'Abteilungsbezeichnung',
    'department.createdBy': 'Erstellt am',
    avContract: 'AV-Vertrag',
    'avContract.name': 'Bezeichnung des AV-Vertrags',
    'avContract.organizationalUnit': 'Organisationseinheit',
    'avContract.responsibleUser': 'Fachverantwortlicher für diesen AV-Vertrag',
    'avContract.principal': 'Auftraggeber',
    'avContract.contractor': 'Auftragnehmer',
    'avContract.isDelegateUnderDsgvo': 'Vertreter gemäß Art. 27 DS-GVO',
    'avContract.contractorDelegate': 'Vertreter Auftragnehmer',
    'avContract.toms': 'Technische und organisatorische Maßnahmen',
    'avContract.date': 'Datum',
    'avContract.isTemplate': 'Vorlage',
    'avContract.isDelete': 'Gelöscht',
    'avContract.isProvedByBehaviorRules': 'die Einhaltung genehmigter Verhaltensregeln gemäß Art. 40 DS-GVO',
    'avContract.isProvedByCert': 'die Zertifizierung nach einem genehmigten Zertifizierungsverfahren gemäß Art. 42 DS-GVO',
    'avContract.isProvedByDocs': 'aktuelle Testate, Berichte oder Berichtsauszüge unabhängiger Instanzen (z.B. Wirtschaftsprüfer, Revision, Datenschutzbeauftragter, IT-Sicherheitsabteilung, Datenschutzauditoren, Qualitätsauditoren)',
    'avContract.isProvedByAudit': 'eine geeignete Zertifizierung durch IT-Sicherheits- oder Datenschutzaudit (z.B. nach BSI-Grundschutz)',
    'avContract.isOtherControlLawMeasures': 'sonstige Maßnahme',
    'avContract.otherControlLawMeasures': 'Beschreiben Sie die Maßnahme',
    'avContract.subjectOfContract': 'Vertragsgegenstand',
    'avContract.hasThirdPartyCountryTransfer': 'Es findet eine Datenübertragung in ein Drittland statt.',
    'avContract.thirdCountryName': 'Name des Drittlandes',
    'avContract.hasAdequacyDecision': 'ist festgestellt durch einen Angemessenheitsbeschluss der Kommission (Art. 45 Abs. 3 DS-GVO)',
    'avContract.hasDataProtectionRegulations': 'wird hergestellt durch verbindliche interne Datenschutzvorschriften (Art. 46 Abs. 2 lit. b i.V.m. 47 DS-GVO)',
    'avContract.hasStandardProtectionClauses': 'wird hergestellt durch Standarddatenschutzklauseln (Art. 46 Abs. 2 litt. c und d DS-GVO)',
    'avContract.hasBehaviorRules': 'wird hergestellt durch genehmigte Verhaltensregeln (Art 46 Abs. 2 lit. e i.V.m. 40 DS-GVO)',
    'avContract.hasCertMechanism': 'wird hergestellt durch einen genehmigten Zertifizierungsmechanismus (Art. 46 Abs. 2 lit. f i.V.m. 42 DS-GVO)',
    'avContract.hasOtherMeasures': 'wird hergestellt durch sonstige Maßnahmen (Art. 46 Abs 2 lit. a, Abs. 3 litt. a und b DS-GVO)',
    'avContract.otherMeasures': 'sonstige Maßnahmen',
    'avContract.subject': 'Gegenstand',
    'avContract.examDate': 'Datum der Prüfung',
    'avContract.examState': 'Prüfungsstatus',
    'avContract.type': 'Typ',
    'avContract.enddateOfTemporaryTask': 'Enddatum des befristeten Auftrags',
    'avContract.cancellationPriod': 'Kündigungsfrist',
    'avContract.mainContract': 'Hauptvertrag',
    'avContract.isQsUnknown': 'Unbekannt',
    'avContract.isDpcRequested': 'Schriftliche Bestellung eines Datenschutzbeauftragten, der seine Tätigkeit gemäß Art. 38 und 39 DS-GVO ausübt.',
    'avContract.areDpcCredsSubmitted': 'Dessen Kontaktdaten werden dem Auftraggeber zum Zweck der direkten Kontaktaufnahme mitgeteilt. Ein Wechsel des Datenschutzbeauftragten wird dem Auftraggeber unverzüglich mitgeteilt.',
    'avContract.areDpcCredsAccessible': 'Dessen jeweils aktuelle Kontaktdaten sind auf der Homepage des Auftragnehmers leicht zugänglich hinterlegt',
    'avContract.isDpcRequestNotObliged': 'Der Auftragnehmer ist nicht zur Bestellung eines Datenschutzbeauftragten verpflichtet.',
    'avContract.hasContactPerson': 'Da der Auftragnehmer seinen Sitz außerhalb der Union hat, benennt er folgenden Vertreter nach Art. 27 Abs. 1 DS-GVO in der Union',
    'avContract.contactPerson': 'Ansprechpartner',
    'avContract.hasOtherObligations': 'Sonstiges Qualitätssicherungen und Pflichten',
    'avContract.otherObligations': 'Text Qualitätssicherungen und Pflichten',
    'avContract.isSubcontrInadmissible': 'Eine Unterbeauftragung ist unzulässig.',
    'avContract.hasPrincipalAcceptedSubcontr': 'Der Auftraggeber stimmt der Beauftragung der nachfolgenden Unterauftragnehmer zu unter der Bedingung einer vertraglichen Vereinbarung nach Maßgabe des Art. 28 Abs. 2-4 DS-GVO',
    'avContract.subcontractors': 'Unterauftragnehmer',
    'avContract.isSubcontrOutsourcingValid': 'Die Auslagerung auf Unterauftragnehmer oder der Wechsel des bestehenden Unterauftragnehmers sind zulässig',
    'avContract.isSubcontractorNotAllowed': 'Eine weitere Auslagerung durch den Unterauftragnehmer ist nicht gestattet',
    'avContract.isMainPrincipalToAsk': 'Eine weitere Auslagerung durch den Unterauftragnehmer bedarf der ausdrücklichen Zustimmung des Hauptauftraggebers (mind. Textform)',
    'avContract.isMainContractorToAsk': 'Eine weitere Auslagerung durch den Unterauftragnehmer bedarf der ausdrücklichen Zustimmung des Hauptauftragnehmers (mind. Textform)',
    'avContract.transferOfficers': 'Weisungsbefugte',
    'avContract.typeOfData': 'Art der Daten',
    'avContract.affectedPersonCategories': 'Kategorien betroffener Personen',
    'avContract.isClientContractor': 'Mandant selbst ist Auftragnehmer',
    'avContract.isClientPrincipal': 'Mandant selbst ist Auftraggeber',
    'avContract.createdBy': 'Ersteller',
    privacyOfficer: 'Datenschutzbeauftragter',
    'privacyOfficer.name': 'Name des Datenschutzbeauftragten',
    'privacyOfficer.firm': 'Firma des Datenschutzbeauftragten',
    'privacyOfficer.street': 'Straß des Datenschutzbeauftragtene',
    'privacyOfficer.zip': 'PLZ des Datenschutzbeauftragten',
    'privacyOfficer.location': 'Ort des Datenschutzbeauftragten',
    'privacyOfficer.phone': 'Telefon des Datenschutzbeauftragten',
    'privacyOfficer.fax': 'Fax des Datenschutzbeauftragten',
    'privacyOfficer.email': 'E-Mail-Adresse des Datenschutzbeauftragten',
    'privacyOfficer.requestDate': 'Bestellungsdatum zum Datenschutzbeauftragten des Datenschutzbeauftragten',
    'privacyOfficer.isInternal': 'intern Angestellt des Datenschutzbeauftragten',
    'privacyOfficer.createdBy': 'Ersteller',
    'user.isInvitedToTraining': 'Zur Schulung eingeladen',
    'user.trainedDate': 'Schulung abgeschlossen am',
  },
};
